import { FormattedMessage } from "react-intl";
import { Link, useLocation } from "react-router-dom";
import type { MessageId } from "../core/messages";
import { parseStarterHandoff } from "../core/starter-handoff";
import pageStyles from "../styles/Page.module.css";

/** The areas a later section brings; each gated route names the one it belongs to. */
export type ComingNextFeature = "wizard" | "builder" | "history" | "marketplace" | "admin";

// The wizard and the builder are one section (projects), so they share the copy; the
// other areas say what THEY are waiting on, never a generic "coming soon".
const COPY: Record<ComingNextFeature, { title: MessageId; body: MessageId }> = {
  wizard: { title: "comingNext.title", body: "comingNext.body" },
  builder: { title: "comingNext.title", body: "comingNext.body" },
  history: { title: "comingNext.history.title", body: "comingNext.history.body" },
  marketplace: { title: "comingNext.marketplace.title", body: "comingNext.marketplace.body" },
  admin: { title: "comingNext.admin.title", body: "comingNext.admin.body" },
};

/**
 * Section 1 interim for the surfaces the next sections bring (owner decision
 * 2026-10-09): a deliberate, honest state instead of an error. The splash's idea rides
 * router state into /start exactly as before; signed in, this panel keeps it on screen
 * so nothing typed is lost. Each gated route reverts to its real element when the
 * matching SECTIONS flag flips.
 */
export function ComingNext({ feature }: { feature: ComingNextFeature }) {
  const location = useLocation();
  const idea = feature === "wizard" ? parseStarterHandoff(location.state) : null;
  const copy = COPY[feature];
  return (
    <div className={pageStyles.page} data-coming-next={feature}>
      <section className={pageStyles.card} role="status">
        <h1 className={pageStyles.title}>
          <FormattedMessage id={copy.title} />
        </h1>
        <p style={{ marginTop: 10 }}>
          <FormattedMessage id={copy.body} />
        </p>
        {idea ? (
          <p style={{ marginTop: 10 }}>
            <FormattedMessage id="comingNext.keptIdea" /> <q data-kept-idea>{idea}</q>
          </p>
        ) : null}
        <p style={{ marginTop: 14 }}>
          <Link to="/templates">
            <FormattedMessage id="comingNext.templates" />
          </Link>
        </p>
      </section>
    </div>
  );
}
